import {
  DOCUMENT,
  DOCUMENTS_ACCESS
} from "@/modules/Document/constants/DocumentConstants";
import { DocumentDTO } from "@/modules/Document/models/DocumentDTO";
import { DocumentQueryDTO } from "@/modules/Document/models/DocumentQueryDTO";
import { DocumentService } from "@/modules/Document/services/DocumentService";
import { EVENT_MESSAGES } from "@/modules/Events/constants/EventConstants";
import { ListService } from "@/modules/List/services/ListService";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  FORM_CONSTANTS,
  FORM_MESSAGES
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { ListCategory } from "@/shared/models/ListCategory";
import { Http } from "@status/codes";
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import Vuetify from "vuetify";
import {
  NOTIFICATION_CONFIG,
  NOTIFICATION_EVENTS
} from "../../constants/NotificationConstants";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import DocumentInfo from "./DocumentInfo/DocumentInfo.vue";
import TooltipButton from "@/shared/components/TooltipButton/TooltipButton.vue";
import { GENERAL_CONSTANTS } from "@/shared/constants/GeneralConstants";
import { LIST_ACCESS } from "@/modules/List/constants/ListConstants";

Vue.use(Vuetify);

@Component({
  name: "DocumentPickerModal",
  components: {
    EmptyState,
    DocumentInfo,
    TooltipButton
  }
})
export default class DocumentPickerModal extends Vue {
  @Prop({ default: false })
  private dialog!: boolean;
  @Prop({ default: "" })
  private userId!: string;
  @Prop({ default: [] })
  private selectedDocuments!: DocumentDTO[];
  @Prop({ default: {} })
  private initialDocument!: DocumentDTO;

  @Inject() documentService!: DocumentService;
  @Inject() listService!: ListService;

  cardClass = STYLE_CLASSES.CARD;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  btnClassTertiary = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  primaryButtonClass = STYLE_CLASSES.PRIMARY_BTN;
  secondaryButtonClass = STYLE_CLASSES.SECONDARY_BTN;

  EMPTY_STATE_HEADER = DOCUMENT.LIST_EMPTY_STATE.HEADER;
  EMPTY_STATE_PARAGRAPH = DOCUMENT.LIST_EMPTY_STATE.PARAGRAPH;
  DOCUMENT_SELECTION = NOTIFICATION_CONFIG.DOCUMENT_MESSAGE.SELECTION;
  DOCUMENT_SEARCH = NOTIFICATION_CONFIG.DOCUMENT_MESSAGE.SEARCH;
  DOCUMENT_SELECTED = NOTIFICATION_CONFIG.DOCUMENT_MESSAGE.SELECTED;
  SAVE_BUTTON = FORM_CONSTANTS.BUTTON.SAVE;
  CLOSE_BUTTON = FORM_CONSTANTS.BUTTON.CLOSE;
  SEARCH_HINT = NOTIFICATION_CONFIG.SEARCH_HINT;
  CATEGORY_LABEL = NOTIFICATION_CONFIG.LABEL.CATEGORY;

  lastRef = "";
  loadingData = false;
  categories: ListCategory[] = [];
  documentList: DocumentDTO[] = [];

  documentQuery: DocumentQueryDTO = {} as DocumentQueryDTO;
  filterCategory: ListCategory = ("" as unknown) as ListCategory;

  async mounted() {
    if (Object.keys(this.initialDocument).length > 0) {
      this.selectedDocuments.push(this.initialDocument);
    }
    await this.loadCategories();
    await this.loadDocuments();
  }

  async loadCategories() {
    try {
      const categoriesListRespose = await this.listService.getCategoriesList();
      if (
        categoriesListRespose.code === Http.Found &&
        categoriesListRespose.data
      ) {
        this.categories = categoriesListRespose.data;
      } else {
        Snackbar.popError(categoriesListRespose.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${LIST_ACCESS.GET}`
          : EVENT_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async searchWithFilter() {
    this.lastRef = "";

    if (Object.keys(this.filterCategory).length === 0) {
      await this.loadDocuments();
    } else {
      const filter: DocumentQueryDTO = {
        category: this.filterCategory.name
      } as DocumentQueryDTO;
      await this.loadDocuments(filter);
    }
  }

  async loadDocuments(filter?: DocumentQueryDTO) {
    try {
      this.loadingData = true;

      this.documentQuery = {
        userId: this.userId,
        sendEmailData: false
      };
      Object.assign(this.documentQuery, filter);

      if (this.lastRef !== "") {
        this.documentQuery.lastRef = this.lastRef;
      }
      const documentDataResponse = await this.documentService.getDocumentByFilter(
        this.documentQuery
      );

      if (
        documentDataResponse.code === Http.Found &&
        documentDataResponse.data
      ) {
        if (documentDataResponse.data.lastReference !== this.lastRef) {
          this.documentList = this.documentList.concat(
            documentDataResponse.data.documentArray
          );
          this.lastRef = documentDataResponse.data.lastReference;
        }
      } else {
        Snackbar.popError(DOCUMENT.MESSAGE.NO_MORE_DATA);
      }
      this.loadingData = false;
    } catch (error) {
      this.loadingData = false;
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${DOCUMENTS_ACCESS.GET}`
          : EVENT_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  addDocument(index: number) {
    const findedIndex = this.selectedDocuments.findIndex(
      document => document._key === this.documentList[index]._key
    );

    if (findedIndex === -1 && this.selectedDocuments.length < 3) {
      this.$emit(NOTIFICATION_EVENTS.DOCUMENT.ADD, this.documentList[index]);
    }
  }

  deleteDocument(index: number) {
    this.$emit(NOTIFICATION_EVENTS.DOCUMENT.DELETE, index);
  }

  saveDocuments() {
    this.$emit(
      NOTIFICATION_EVENTS.DOCUMENT.FILES_CHOSEN,
      this.selectedDocuments
    );
  }

  closeModal() {
    this.$emit(NOTIFICATION_EVENTS.DOCUMENT.CLOSE_MODAL);
  }
}
